import React, { useContext } from 'react';

import { GlobalStyleRuleSearch } from 'components/modules/style-rules/components';
import { StyleRulesSettingsTabContext } from 'components/pages/StyleRulesPage/components/SettingsTab/SettingsTab.context';

import './StyleRulesSettingsTopControls.scss';

const propTypes = {};

const defaultProps = {};

export default function StyleRulesSettingsTopControls() {
  const { styleRuleConfigurations, onSelectFolder, onSelectHighlightedStyleRule } = useContext(
    StyleRulesSettingsTabContext,
  );

  return (
    <div className="style-rules-settings-top-controls">
      <GlobalStyleRuleSearch
        styleRuleConfigurations={styleRuleConfigurations}
        onSelectStyleRule={onSelectHighlightedStyleRule}
        onSelectFolder={onSelectFolder}
      />
    </div>
  );
}

StyleRulesSettingsTopControls.propTypes = propTypes;
StyleRulesSettingsTopControls.defaultProps = defaultProps;
